export function materialOrderNumber(order) {
  return order.order_number || 'Pendiente de numeración';
}
